"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MicOn = void 0;
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["volume"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var MicOn = function MicOn(props) {
  var volume = props.volume,
    restProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, _extends({
    viewBox: "0 0 14 19"
  }, restProps), /*#__PURE__*/_react.default.createElement("svg", {
    version: "1.1",
    width: "14",
    height: "19",
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "round-corner"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "4",
    height: "10",
    rx: "2",
    ry: "2"
  }))), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 8.5332H11.9295C11.9295 9.9258 11.4351 11.0814 10.4463 11.9999C9.48658 12.8888 8.33781 13.3332 7 13.3332C5.66219 13.3332 4.49888 12.8888 3.51007 11.9999C2.55034 11.0814 2.07047 9.9258 2.07047 8.5332H0.5C0.5 10.1332 1.03803 11.5406 2.11409 12.7554C3.21924 13.9406 4.54251 14.6517 6.08389 14.8888V16.9999H3.25V18.4999H10.75V16.9999H7.91611V14.8888C9.45749 14.6517 10.7662 13.9406 11.8423 12.7554C12.9474 11.5406 13.5 10.1332 13.5 8.5332Z",
    fill: "#EEEEF3"
  }), /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(5 11) scale(1 -1)",
    clipPath: "url(#round-corner)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "4",
    fill: "#EEEEF3",
    style: {
      height: Math.min(volume, 10),
      transition: "height 0.1s ease 0.1s"
    }
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.60816 10.1831C8.14507 10.6549 7.61749 10.8778 7.00191 10.8778C6.38633 10.8778 5.85875 10.6549 5.39565 10.1831C4.93238 9.71111 4.70996 9.16924 4.70996 8.53333V2.84444C4.70996 2.20854 4.93238 1.66667 5.39565 1.19469C5.85875 0.722887 6.38633 0.5 7.00191 0.5C7.61749 0.5 8.14507 0.722887 8.60816 1.19469C9.07143 1.66667 9.29385 2.20854 9.29385 2.84444V8.53333C9.29385 9.16924 9.07143 9.71111 8.60816 10.1831Z",
    stroke: "#EEEEF3"
  })));
};
exports.MicOn = MicOn;